
function showStatusMessage(msg,timeout){
  timeout = timeout || 1500;
  $('.status-msg .inner-msg').html(msg);
  $('.status-msg').addClass('visible');
  setTimeout(function(){$('.status-msg').removeClass('visible');}, timeout);
}

/* for shipping charge */

var postcode = localStorage.getItem("postcode");
var delivery_rate_id;

var deliveryRateAdded = false;
$('.btn-checkout-btn').click(function(e){
   e.preventDefault();

  setdeliveryid();
  // Count only soups
  var soupCount = 0;
  for (ci = 0; ci < cart_items.length; ci++)
  {
    if (cart_items[ci].product_type === "Build-a-Box") {
      soupCount += 15;
    }
    else if (cart_items[ci].handle != "cooler-pack") {
      soupCount += cart_items[ci].quantity;
    }
  }
  
  
  if(!localStorage.getItem("postcode")) {
   showStatusMessage('Please enter postcode!');
  }
  if(!cartContainsDeliveryRate() && !deliveryRateAdded){
    if (typeof delivery_rate_id !== 'undefined') {
      e.preventDefault();
      jQuery.post('/cart/add.js', {id: delivery_rate_id, quantity: 1}, function(response){
        deliveryRateAdded = true;
    	$('.btn-checkout-btn').click();
      }, 'json');
    }
    return false; 
  }
  
  return deliveryRateAdded;
});



if(delivery_rates != ''){
 setdeliveryid();
}
function setdeliveryid(){
    postcode = localStorage.getItem("postcode");
  $.each(delivery_rates, function(i, val){
    var _descel = $('<div>' + val.description + '</div>').text();
    if(_descel.trim().split(',').map(function(x){return x.trim();}).indexOf(postcode)>=0){
      delivery_rate_id = val.variants[0].id;
      return;
    }
  });

}
function cartContainsDeliveryRate(){
  for(var i in cart_items){
    if(cart_items[i].product_type == 'Delivery Rate'){
      return true;
    }
  }
  return false;
}

function clearDeliveryCharges(){
    for (ci = 0; ci < cart_items.length; ci++)
  {
    if (cart_items[ci].product_type === "Delivery Rate") {
        $.post('/cart/change.js', {
        id: cart_items[ci].key,
        quantity: 0
        })
        .done(function(response) {
        })
        .fail(function(error) {
        });

    }
  }
   jQuery.getJSON('/cart.js', function(r){
      cart_items = [r];
    });
 
};

if(cartContainsDeliveryRate()){
  clearDeliveryCharges();
}

